var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardTeamMembers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "badge_black_24dp_1_",
    "data-name": "badge_black_24dp (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_785",
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1292",
    "data-name": "Rectangle 1292",
    width: 28,
    height: 28,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_787",
    "data-name": "Group 787",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_786",
    "data-name": "Group 786"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1293",
    "data-name": "Rectangle 1293",
    width: 4,
    height: 1.5,
    transform: "translate(14.842 11.911)",
    fill: "#C4141B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1294",
    "data-name": "Rectangle 1294",
    width: 4,
    height: 1.5,
    transform: "translate(14.842 15.484)",
    fill: "#C4141B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M23.41,7.884H17.463V4.354A2.373,2.373,0,0,0,15.084,2H12.705a2.373,2.373,0,0,0-2.379,2.354v3.53H4.379A2.373,2.373,0,0,0,2,10.237V23.182a2.373,2.373,0,0,0,2.379,2.354H23.41a2.373,2.373,0,0,0,2.379-2.354V10.237A2.373,2.373,0,0,0,23.41,7.884Zm-10.705,0V4.354h2.379v5.884H12.705Zm10.705,15.3H4.379V10.237h5.947a2.373,2.373,0,0,0,2.379,2.354h2.379a2.373,2.373,0,0,0,2.379-2.354H23.41Z",
    transform: "translate(-2 -2)",
    fill: "#C4141B"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_227",
    "data-name": "Ellipse 227",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(6.726 12.08)",
    fill: "#C4141B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M11.08,16.18a5.246,5.246,0,0,0-4.16,0A1.506,1.506,0,0,0,6,17.57V18h6v-.43A1.506,1.506,0,0,0,11.08,16.18Z",
    transform: "translate(-0.917 0.739)",
    fill: "#C4141B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTeamMembers);
export default __webpack_public_path__ + "static/media/dashboard_team_members.f1aabe1c708ba266a4171f34d75dc894.svg";
export { ForwardRef as ReactComponent };